var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoodItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.75C3.0335 1.75 2.25 2.5335 2.25 3.5C2.25 4.4665 3.0335 5.25 4 5.25C4.9665 5.25 5.75 4.4665 5.75 3.5C5.75 2.5335 4.9665 1.75 4 1.75ZM0.75 3.5C0.75 1.70507 2.20507 0.25 4 0.25C5.79493 0.25 7.25 1.70507 7.25 3.5C7.25 5.29493 5.79493 6.75 4 6.75C2.20507 6.75 0.75 5.29493 0.75 3.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.25C3.0335 9.25 2.25 10.0335 2.25 11C2.25 11.9665 3.0335 12.75 4 12.75C4.9665 12.75 5.75 11.9665 5.75 11C5.75 10.0335 4.9665 9.25 4 9.25ZM0.75 11C0.75 9.20507 2.20507 7.75 4 7.75C5.79493 7.75 7.25 9.20507 7.25 11C7.25 12.7949 5.79493 14.25 4 14.25C2.20507 14.25 0.75 12.7949 0.75 11Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.75C3.0335 16.75 2.25 17.5335 2.25 18.5C2.25 19.4665 3.0335 20.25 4 20.25C4.84576 20.25 5.5529 19.6493 5.71498 18.8508C5.73786 18.7381 5.75 18.6208 5.75 18.5C5.75 18.0858 6.08579 17.75 6.5 17.75C6.91421 17.75 7.25 18.0858 7.25 18.5C7.25 18.7216 7.22771 18.9388 7.185 19.1492C6.88381 20.633 5.57319 21.75 4 21.75C2.20507 21.75 0.75 20.2949 0.75 18.5C0.75 16.7051 2.20507 15.25 4 15.25C4.41421 15.25 4.75 15.5858 4.75 16C4.75 16.4142 4.41421 16.75 4 16.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3.5C8.75 3.08579 9.08579 2.75 9.5 2.75H18.5C18.9142 2.75 19.25 3.08579 19.25 3.5C19.25 3.91421 18.9142 4.25 18.5 4.25H9.5C9.08579 4.25 8.75 3.91421 8.75 3.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 11C8.75 10.5858 9.08579 10.25 9.5 10.25H18.5C18.9142 10.25 19.25 10.5858 19.25 11C19.25 11.4142 18.9142 11.75 18.5 11.75H9.5C9.08579 11.75 8.75 11.4142 8.75 11Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 18.5C8.75 18.0858 9.08579 17.75 9.5 17.75H18.5C18.9142 17.75 19.25 18.0858 19.25 18.5C19.25 18.9142 18.9142 19.25 18.5 19.25H9.5C9.08579 19.25 8.75 18.9142 8.75 18.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodItem);
export default __webpack_public_path__ + "static/media/food-item.a70bd6e41deb74c07fdd6a3eff180468.svg";
export { ForwardRef as ReactComponent };